/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyTagDto } from '../../models/company-tag-dto';
import { SetCompanyTagsRequest } from '../../models/set-company-tags-request';

export interface SetCompanyAssociatedTags$Params {
  id: number;
      body: SetCompanyTagsRequest
}

export function setCompanyAssociatedTags(http: HttpClient, rootUrl: string, params: SetCompanyAssociatedTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyTagDto>>> {
  const rb = new RequestBuilder(rootUrl, setCompanyAssociatedTags.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyTagDto>>;
    })
  );
}

setCompanyAssociatedTags.PATH = '/api/companies/{id}/tags';
